<template>
    <div class="new_energy_manage">
        <!-- <div class="leader-tab">
            <el-tabs v-model="tab_value" type="card">
                <el-tab-pane label="光伏" name="tab1"></el-tab-pane>
                <el-tab-pane label="储能" name="tab2"></el-tab-pane>
                <el-tab-pane label="充电桩" name="tab3"></el-tab-pane>
            </el-tabs>
        </div>
        <div class="form-box">
            <el-form
                :model="formModel"
                label-width="100px"
                inline
                label-position="left"
                class="leader-style-form"
            >
                <el-form-item label="缺陷来源">
                    <el-input v-model="formModel.resource"></el-input>
                </el-form-item>
                <el-form-item label="缺陷单号">
                    <el-input v-model="formModel.number"></el-input>
                </el-form-item>
                <el-form-item label="缺陷发现人">
                    <el-input v-model="formModel.person"></el-input>
                </el-form-item>
                <el-form-item label="缺陷发现日期">
                    <el-date-picker
                        type="date"
                        placeholder="选择日期"
                        v-model="formModel.date"
                        style="width: 100%;"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item style="float: right">
                    <el-button>查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="table-wrap" style="height: 85%;">
            <el-table class="leader-style-table" :data="tableData">
                <el-table-column width="50" align="center" label="序号">
                    <template slot-scope="scope">
                        <span>{{ scope.$index + 1 }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="缺陷单号"
                    align="center"
                    property="p1"
                ></el-table-column>
                <el-table-column
                    label="缺陷设备名称"
                    align="center"
                    property="p2"
                ></el-table-column>
                <el-table-column
                    label="缺陷性质"
                    align="center"
                    property="p3"
                ></el-table-column>
                <el-table-column
                    label="发现人"
                    align="center"
                    property="p4"
                ></el-table-column>
                <el-table-column
                    label="发现时间"
                    align="center"
                    property="p5"
                ></el-table-column>
                <el-table-column
                    label="缺陷来源"
                    align="center"
                    property="p6"
                ></el-table-column>
                <el-table-column
                    label="缺陷状态"
                    align="center"
                    property="p7"
                ></el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" class="leader-button">
                            <span class="inner-text">查看</span>
                        </el-button>
                        <el-button type="text" class="leader-button">
                            <span class="inner-text">修改</span>
                        </el-button>
                        <el-button type="text" class="leader-button">
                            <span class="inner-text">删除</span>
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <pagination
                class="leader-style-pagination"
                :paginationData="paginationData"
            ></pagination>
        </div> -->
    </div>
</template>
<script>
import pagination from "@/comon/components/pagination.vue";
export default {
    components: {
        pagination
    },
    data() {
        return {
            tab_value: "tab1",
            formModel: {
                resource: "", //缺陷来源
                number: "", //缺陷单号
                person: "", //缺陷发现人
                date: "" //缺陷发现日期
            },
            tableData: [
                {
                    p1: "111",
                    p2: "设备1",
                    p3: "一般",
                    p4: "张三",
                    p5: "2023-03-08",
                    p6: "检修",
                    p7: "已完成"
                }
            ], //表格数据
            paginationData: {
                pageNum: "1",
                pageSize: "1",
                totalNum: "1"
            }
        };
    }
};
</script>
<style lang="scss">
.new_energy_manage {
    width: 100%;
    height: 100%;
    padding: 0 40px;
    box-sizing: border-box;
    background: url("../../../../assets/image/custom/energy_manage_bac.png") no-repeat;
    -webkit-background-size: 100% 100%;
    background-size: 100% 100%;
    .form-box {
        width: 100%;
    }
}
</style>
